import * as React from "react";
import clsx from "clsx";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import { SAFE_PLACE_TYPE } from "@dpdgroupuk/redback-enums";
import Porch from "../Icons/Porch";
import Garage from "../Icons/Garage";
import Shed from "../Icons/Shed";
import RearPorch from "../Icons/RearPorch";
import Radio from "../Icons/Radio";
const useStyles = makeStyles(({
  breakpoints,
  palette,
  typography
}) => ({
  container: {
    display: "flex",
    width: "100%",
    justifyContent: "space-between",
    alignItems: "center",
    margin: `${typography.pxToRem(30)} 0 ${typography.pxToRem(30)}`,
    cursor: "pointer",
    "&:hover .safePlaceIcon": {
      fill: palette.primary.main
    }
  },
  label: {
    [breakpoints.down("sm")]: {
      fontSize: typography.pxToRem(16)
    },
    fontSize: typography.pxToRem(19),
    lineHeight: 0.85,
    letterSpacing: 0.44,
    fontWeight: "normal"
  },
  leftContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center"
  },
  icon: {
    [breakpoints.down("sm")]: {
      fontSize: typography.pxToRem(25)
    },
    fontSize: typography.pxToRem(30),
    marginRight: typography.pxToRem(20),
    "& .checkMark": {
      fill: palette.primary.main
    }
  },
  radioIcon: {
    "& .checkMark": {
      fill: palette.primary.main
    }
  },
  selected: {
    "& .safePlaceIcon": {
      fill: palette.primary.main
    }
  }
}));

const getSafePlaceIcon = safePlace => {
  switch (safePlace) {
    case SAFE_PLACE_TYPE.FPC:
      return Porch;

    case SAFE_PLACE_TYPE.GAR:
      return Garage;

    case SAFE_PLACE_TYPE.OBL:
      return Shed;

    case SAFE_PLACE_TYPE.RPC:
      return RearPorch;

    default:
      throw new Error("Icon not found");
  }
};

export default (({
  place,
  onSelect,
  selected
}) => {
  const styles = useStyles();
  const IconComponent = getSafePlaceIcon(place.id);
  return /*#__PURE__*/React.createElement("div", {
    className: styles.container,
    onClick: () => onSelect(place)
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.leftContainer
  }, /*#__PURE__*/React.createElement(IconComponent, {
    className: clsx(styles.icon, selected && styles.selected)
  }), /*#__PURE__*/React.createElement(Typography, {
    className: styles.label
  }, place.name)), /*#__PURE__*/React.createElement(Radio, {
    selected: selected,
    className: styles.radioIcon
  }));
});